import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { getStoredAuthToken } from '../../auth/auth-token';

@Injectable({ providedIn: 'root' })
export class UserProfileService {
  private userProfileCache$: Observable<any> | null = null;
  private lastFetchTime = 0;
  private readonly CACHE_TTL_MS = 30_000;

  constructor(private http: HttpClient) {}

  getUserProfile(force = false): Observable<any> {
    const token = getStoredAuthToken();
    if (!token) {
      return of(null);
    }

    const now = Date.now();
    if (!force && this.userProfileCache$ && (now - this.lastFetchTime < this.CACHE_TTL_MS)) {
      return this.userProfileCache$;
    }

    this.lastFetchTime = now;
    const params = new HttpParams().set('access_token', token);

    this.userProfileCache$ = this.http.get<any>(`${environment.backendUrl}/api/u/profile-details`, { params }).pipe(
      catchError(() => of(null)),
      shareReplay({ bufferSize: 1, refCount: false })
    );

    return this.userProfileCache$;
  }

  isAdmin(): Observable<boolean> {
    const token = getStoredAuthToken();
    if (!token) {
      return of(false);
    }

    // Check fast session cache first if available
    if (typeof sessionStorage !== 'undefined') {
      try {
        const raw = sessionStorage.getItem('session');
        if (raw) {
          const parsed = JSON.parse(raw);
          const u = parsed?.user_info;
          if (u && (u.is_admin || u.is_super_admin)) {
            return of(true);
          }
        }
      } catch (_) {}
    }

    return this.getUserProfile().pipe(
      map(user => !!(user && (user.is_admin || user.is_super_admin))),
      catchError(() => of(false))
    );
  }
}
